module.exports = __webpack_public_path__ + "media/application/images/2018/insta-white-f840162bd0cea74c8527b3317aea4a17.svg";